<template>
  <el-dialog
    title="预约单元数量编辑"
    :visible.sync="isShowConfigPanel"
    :close-on-click-modal="false"
    :show-close="false"
    width="1800px"
    class="reserve-operation-wrapper"
  >
    <div class="content-wrap">
      <div class="title-box">
        <div class="text-item">  </div>
        <div class="text-item">项目名称</div>
        <div class="text-item">星期一上午</div>
        <div class="text-item">星期一下午</div>
        <div class="text-item">星期二上午</div>
        <div class="text-item">星期二下午</div>
        <div class="text-item">星期三上午</div>
        <div class="text-item">星期三下午</div>
        <div class="text-item">星期四上午</div>
        <div class="text-item">星期四下午</div>
        <div class="text-item">星期五上午</div>
        <div class="text-item">星期五下午</div>
        <div class="text-item">星期六上午</div>
        <div class="text-item">星期六下午</div>
        <div class="text-item">星期日上午</div>
        <div class="text-item">星期日下午</div>
      </div>
      <!-- <div class="input-wrap"> -->
      <div >
        <div class="input-wrap" v-for="(item, key) in tableData"  v-bind:key="key" >          
          <div class="input-item">操作单元数量</div>
          <div class="input-item" v-for="(cvalue, ckey) in key_order" v-bind:key="ckey">
            <input
                class="input"
                type="text"
                placeholder=""
                maxlength="2"                
                v-model="item[cvalue]"
                @input="cvalue=='operation_name'? item[cvalue]=item[cvalue] : item[cvalue]=item[cvalue].replace(/[^\d]/g, '')"
            >
          </div>
          <div>
              <br>
          </div>            
        </div>
      </div>
      <!-- <div class="input-wrap">
        <div class="input-item">操作单元数量</div>
        <div class="input-item" v-for="(value, key) in formData">
          <input
            class="input"
            type="text"
            placeholder=""
            maxlength="2"
            v-model="formData[key]"
            @input="formData[key] = formData[key].replace(/[^\d]/g, '')"
          >
        </div>
      </div> -->

    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="confirm" style="margin-left: 20px">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import gql from 'graphql-tag';
  
  export default {
    
    props: {
      isShowConfigPanel: Boolean,
    },
    
    data() {
      //leaderId的命名存在歧义，起作用是临时存储手术数量表的id字段；teamId的作用是存储leader_id；by zdh
      return {
        dialogVisible: true,
        formData: {
          monday: '',
          tuesday: '',
          wednesday: '',
          thursday: '',
          friday: '',
          saturday: '',
          sunday: '',
        },
        configItem: {
            id: '',
            operation_name: '', 
            monday_am: '', 
            monday_pm: '', 
            tuesday_am: '', 
            tuesday_pm: '', 
            wednesday_am: '', 
            wednesday_pm: '', 
            thursday_am: '', 
            thursday_pm: '', 
            friday_am: '', 
            friday_pm: '', 
            saturday_am: '', 
            saturday_pm: '', 
            sunday_am: '', 
            sunday_pm: '',
        },
        //每个元素都是一个配置条目，一个leader_id下，根据operation_name 的不同，可能有多个配置条目
        tableData:[],

        
        leaderId: -1,
        teamId: -1,
        // 后台返回的配置{}, 按照这个顺序进行展示
        key_order: ["operation_name", "monday_am", "monday_pm", "tuesday_am", "tuesday_pm", "wednesday_am", "wednesday_pm", 
            "thursday_am", "thursday_pm", "friday_am", "friday_pm", "saturday_am", "saturday_pm", "sunday_am","sunday_pm"],
      };
    },
    
    methods: {
      cancel() {
        this.$emit('closeConfigPanel');
      },
      //在后台预先设置N个预约项目，初始数值为0，用户可以修改，但不能新增
      async confirm() {
        // if (this.leaderId === -1) {
        //   console.log("Begin addCosmetRegistrationConfig");
        //   await this.addCosmetRegistrationConfig();
        // } else {
        // console.log("Begin modifyCosmetRegistrationConfig");
        await this.modifyCosmetRegistrationConfig();
        // modifyCosmetRegistrationConfig
        //}
        this.$message({
          message: '保存成功',
          type: 'success',
        });
        this.$emit('closeConfigPanel');
        
        this.getcosmetRegistrationLeft();
        
      },
      
      //新增配置
      async addCosmetRegistrationConfig() {
        try {
            operation_names = [];
            const tableData = this.tableData;
            tableData.forEach((tmp_item,tmp_index,tableData) => {
                operation_names.push(tmp_item.operation_name)
            });
            let has_repeat = false;
            let nary=operation_names.sort();
            //是否有重复的项目名称
            for(var i=0;i<operation_names.length-1;i++){
                if (nary[i]==nary[i+1]){
                    has_repeat = true;
                }
            }
            if ( has_repeat){
                this.$message.error("项目名称不能重复！");
            }else {                
                tableData.forEach((tmp_item,tmp_index, tableData) => {    
                    //  foreach 内不能使用await      
                    //await this.$apollo.mutate({
                    this.$apollo.mutate({
                        mutation: gql`mutation(
                            team_id: Int!
                            operation_name: String!
                            monday_am: Int!
                            monday_pm: Int!
                            tuesday_am: Int!
                            tuesday_pm: Int!
                            wednesday_am: Int!
                            wednesday_pm: Int!
                            thursday_am: Int!
                            thursday_pm: Int!
                            friday_am: Int!
                            friday_pm: Int!
                            saturday_am: Int!
                            saturday_pm: Int!
                            sunday_am: Int!
                            sunday_pm: Int!
                        ){
                        addCosmetRegistrationConfig(
                            team_id: $team_id,                
                            operation_name: $operation_name,
                            monday_am: $monday_am,
                            monday_pm: $monday_pm,
                            tuesday_am: $tuesday_am,
                            tuesday_pm: $tuesday_pm,
                            wednesday_am: $wednesday_am,
                            wednesday_pm: $wednesday_pm,
                            thursday_am: $thursday_am,
                            thursday_pm: $thursday_pm,
                            friday_am: $friday_am,
                            friday_pm: $friday_pm,
                            saturday_am: $saturday_am,
                            saturday_pm: $saturday_pm,
                            sunday_am: $sunday_am,
                            sunday_pm: $sunday_pm
                        ){
                            id
                        }
                        }`,
                        variables: {
                            team_id: this.teamId,
                            monday_am: tmp_item.monday_am ? Number(tmp_item.monday_am) : 0,
                            monday_pm: tmp_item.monday_pm ? Number(tmp_item.monday_pm) : 0,
                            tuesday_am: tmp_item.tuesday_am ? Number(tmp_item.tuesday_am) : 0,
                            tuesday_pm: tmp_item.tuesday_pm ? Number(tmp_item.tuesday_pm) : 0,
                            wednesday_am: tmp_item.wednesday_am ? Number(tmp_item.wednesday_am) : 0,
                            wednesday_pm: tmp_item.wednesday_pm ? Number(tmp_item.wednesday_pm) : 0,
                            thursday_am: tmp_item.thursday_am ? Number(tmp_item.thursday_am) : 0,
                            thursday_pm: tmp_item.thursday_pm ? Number(tmp_item.thursday_pm) : 0,
                            friday_am: tmp_item.friday_am ? Number(tmp_item.friday_am) : 0,              
                            friday_pm: tmp_item.friday_pm ? Number(tmp_item.friday_pm) : 0,
                            saturday_am: tmp_item.saturday_am ? Number(tmp_item.saturday_am) : 0,
                            saturday_pm: tmp_item.saturday_pm ? Number(tmp_item.saturday_pm) : 0,
                            sunday_am: tmp_item.sunday_am ? Number(tmp_item.sunday_am) : 0,
                            sunday_pm: tmp_item.sunday_pm ? Number(tmp_item.sunday_pm) : 0
                        },
                    });

                });
                // console.log("In cosmetRegConfig, addd new configItem:", tmp_item);
            }
        }catch(error){
            this.$message.error(error.message.split(':')[1]);
        }
      },

      //修改配置
      async modifyCosmetRegistrationConfig() {
        try {
            // console.log("Come into modifyCosmetRegistrationConfig");
            let operation_names = []; 
            const tableData = this.tableData;
            tableData.forEach((tmp_item,tmp_index,tableData) => {
                operation_names.push(tmp_item.operation_name);
            });
            //console.log("in modifyCosmetRegistrationConfig, operation_names:",operation_names);
            let has_repeat = false;
            let nary=operation_names.sort();
            //是否有重复的项目名称
            for(var i=0;i<operation_names.length-1;i++){
                if (nary[i]==nary[i+1]){
                    has_repeat = true;
                }
            }
            // console.log("in modifyCosmetRegistrationConfig, operation_names:",operation_names,", has_repeat:",has_repeat);
            if ( has_repeat){
                this.$message.error("项目名称不能重复！");
            }else {
                tableData.forEach((tmp_item,tmp_index,tableData) => {            
                    this.$apollo.mutate({
                        mutation: gql`mutation(
                            $id: Int!
                            $operation_name: String
                            $monday_am: Int
                            $monday_pm: Int
                            $tuesday_am: Int
                            $tuesday_pm: Int
                            $wednesday_am: Int
                            $wednesday_pm: Int
                            $thursday_am: Int
                            $thursday_pm: Int
                            $friday_am: Int
                            $friday_pm: Int
                            $saturday_am: Int
                            $saturday_pm: Int
                            $sunday_am: Int
                            $sunday_pm: Int
                        ){
                        modifyCosmetRegistrationConfig(
                            id: $id,                
                            operation_name: $operation_name,
                            monday_am: $monday_am,
                            monday_pm: $monday_pm,
                            tuesday_am: $tuesday_am,
                            tuesday_pm: $tuesday_pm,
                            wednesday_am: $wednesday_am,
                            wednesday_pm: $wednesday_pm,
                            thursday_am: $thursday_am,
                            thursday_pm: $thursday_pm,
                            friday_am: $friday_am,
                            friday_pm: $friday_pm,
                            saturday_am: $saturday_am,
                            saturday_pm: $saturday_pm,
                            sunday_am: $sunday_am,
                            sunday_pm: $sunday_pm
                        )
                        }`,
                        variables: {
                            id: tmp_item.id ? Number(tmp_item.id) : -1,
                            operation_name: tmp_item.operation_name,
                            monday_am: tmp_item.monday_am ? Number(tmp_item.monday_am) : 0,
                            monday_pm: tmp_item.monday_pm ? Number(tmp_item.monday_pm) : 0,
                            tuesday_am: tmp_item.tuesday_am ? Number(tmp_item.tuesday_am) : 0,
                            tuesday_pm: tmp_item.tuesday_pm ? Number(tmp_item.tuesday_pm) : 0,
                            wednesday_am: tmp_item.wednesday_am ? Number(tmp_item.wednesday_am) : 0,
                            wednesday_pm: tmp_item.wednesday_pm ? Number(tmp_item.wednesday_pm) : 0,
                            thursday_am: tmp_item.thursday_am ? Number(tmp_item.thursday_am) : 0,
                            thursday_pm: tmp_item.thursday_pm ? Number(tmp_item.thursday_pm) : 0,
                            friday_am: tmp_item.friday_am ? Number(tmp_item.friday_am) : 0,              
                            friday_pm: tmp_item.friday_pm ? Number(tmp_item.friday_pm) : 0,
                            saturday_am: tmp_item.saturday_am ? Number(tmp_item.saturday_am) : 0,
                            saturday_pm: tmp_item.saturday_pm ? Number(tmp_item.saturday_pm) : 0,
                            sunday_am: tmp_item.sunday_am ? Number(tmp_item.sunday_am) : 0,
                            sunday_pm: tmp_item.sunday_pm ? Number(tmp_item.sunday_pm) : 0
                        },
                    });
                  // console.log("In cosmetRegConfig, modify configItem:", tmp_item);
                });
                
            }
        }catch(error){
            this.$message.error(error);
            console.log(error);
            //this.$message.error(error.message.split(':')[1]);
        }
       },


      // 查询团队预约设置情况
      async getcosmetRegistrationLeft() {
        try {
          const res = await this.$apollo.query({
            query: gql`{
              me{
                id
                leader_id
              }
            }`,
            fetchPolicy: "no-cache",
          });
          this.teamId = res.data.me.leader_id;
          const res1 = await this.$apollo.query({
            query: gql`{
              getcosmetRegistrationLeft(leaderid: ${res.data.me.leader_id}){
                id,
                operation_name, 
                monday_am, 
                monday_pm, 
                tuesday_am, 
                tuesday_pm, 
                wednesday_am, 
                wednesday_pm, 
                thursday_am, 
                thursday_pm, 
                friday_am, 
                friday_pm, 
                saturday_am, 
                saturday_pm, 
                sunday_am, 
                sunday_pm
              }
            }`,
            fetchPolicy: "no-cache",
          });
          // console.log("In cosmetRegConfig, getcosmetRegistrationLeft:",res1.data.getcosmetRegistrationLeft);
          let tmp_table_data = [];
          if (res1.data.getcosmetRegistrationLeft) {
            const resData = res1.data.getcosmetRegistrationLeft;
            let tmp_length = resData.length;
            resData.forEach((tmp_item,tmp_index,resData) => {
                this.configItem = {
                    id: String(tmp_item.id),
                    operation_name: String(tmp_item.operation_name), 
                    monday_am: String(tmp_item.monday_am),  
                    monday_pm: String(tmp_item.monday_pm), 
                    tuesday_am: String(tmp_item.tuesday_am), 
                    tuesday_pm: String(tmp_item.tuesday_pm), 
                    wednesday_am: String(tmp_item.wednesday_am), 
                    wednesday_pm: String(tmp_item.wednesday_pm), 
                    thursday_am: String(tmp_item.thursday_am), 
                    thursday_pm: String(tmp_item.thursday_pm), 
                    friday_am: String(tmp_item.friday_am), 
                    friday_pm: String(tmp_item.friday_pm), 
                    saturday_am: String(tmp_item.saturday_am), 
                    saturday_pm: String(tmp_item.saturday_pm), 
                    sunday_am: String(tmp_item.sunday_am), 
                    sunday_pm: String(tmp_item.saturday_pm) 

                };
                // console.log("In cosmetRegConfig, configItem:", this.configItem);
                tmp_table_data.push(this.configItem);                
            });

            // this.formData = {
            //   monday: String(resData.monday),
            //   tuesday: String(resData.tuesday),
            //   wednesday: String(resData.wednesday),
            //   thursday: String(resData.thursday),
            //   friday: String(resData.friday),
            //   saturday: String(resData.saturday),
            //   sunday: String(resData.sunday),
            // };
            //this.leaderId = resData.id;
            this.tableData = tmp_table_data;
          } else {
            // this.formData = {
            //   monday: '0',
            //   tuesday: '0',
            //   wednesday: '0',
            //   thursday: '0',
            //   friday: '0',
            //   saturday: '0',
            //   sunday: '0',
            // };
            this.tableData = [];
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      }
    },
    
    mounted() {
      this.getcosmetRegistrationLeft();
    },
  }
</script>

<style>
  /*dialog样式修改*/
  .reserve-operation-wrapper .el-dialog__header .el-dialog__title{
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .reserve-operation-wrapper .el-dialog__header{
    padding: 20px 24px 10px;
  }
  .reserve-operation-wrapper .el-dialog__body {
    padding: 0 20px;
  }
  .reserve-operation-wrapper .el-dialog__close{
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
</style>
<style lang="less" scoped>
  .reserve-operation-wrapper{
    input{
      padding: 0;
      border: 0;
    }
  }
  .reserve-operation-wrapper{
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    min-width: 1600px;
    
    .content-wrap{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-top: 2px solid #4da3c0;
      padding: 50px 0;
      .title-box{
        display: flex;
        .text-item{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 70px;
          box-sizing: border-box;
          background-color: #d5d5d5;
          border-bottom: 1px solid #ababab;
        }
        .text-item + .text-item{
          border-left: 1px solid #ababab;
        }
        .text-item:nth-of-type(1){
          width: 100px;
        }
      }
      .input-wrap{
        display: flex;
        align-items: flex-end;
        .input-item{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 70px;
          box-sizing: border-box;
          background-color: #d5d5d5;
          .input{
            width: 100%;
            height: 100%;
            text-align: center;
            outline: none;
          }
        }
        .input-item:nth-of-type(1){
          width: 100px;
        }
        .input-item + .input-item{
          background-color: #ffffff;
          border-left: 1px solid #ababab;
          border-bottom: 1px solid #dadada;
        }
        .input-item:nth-child(8){
          border-right: 1px solid #dadada;
        }
        .confirm-btn{
          width: 110px;
          height: 40px;
          background-color: #4da3c0;
          border-radius: 10px;
          color: #fff;
          margin-left: 82px;
          cursor: pointer;
          user-select: none;
          text-align: center;
          line-height: 40px;
          font-size: 15px;
          letter-spacing: 5px;
        }
      }
    }
    .content-list-wrap{
      height: calc(100% - 220px);
      padding-top: 20px;
      box-sizing: border-box;
    }
    .dialog-footer{
      padding-right: 17px;
    }
  }
</style>
